<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>

const defaultLayout = 'default';

import { mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "app",
  computed: {
    ...mapGetters(['prevTargetUrl', 'requestsFailed']),
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout';
    }
  },
  methods: {
    ...mapMutations(['addRequest', 'addErrorResponse', 'addResponse']),
  },

  beforeCreate() {
    //---=== REQUEST ===---
    axios.interceptors.request.use(
      config => {
        const token = localStorage.getItem('auth_token')
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }
        const customConfig = {
          ...config,
          customDebugInfo: {
            requestView: this.$route.name,
            requestHref: window.location.href,
            requestId: uuidv4(),
            status: 'pending'
          }
        }
        this.addRequest(customConfig);
        return customConfig;
      },
      error => { throw error },
    );
    //---=== RESPONSE ===---
    axios.interceptors.response.use(
      response => {
        this.addResponse(response);
        return response;
      },
      error => {
        const { message, config, code, request, response } = error;
        this.addErrorResponse({
          message,
          config,
          code,
          request,
          response,
        })
        if (response && response.status === 401) {
          this.$router.push('/admin/logout');
        } else {
          throw error;
        }
      }
    );
  },
}

</script>

<style>
html>body {
  /* @TBD: background color for the whole document? */
  background-color: white;
  /* @TBD: font family fallback 'roboto'? */
  font-family: Weiter Sans, Roboto, Helvetica Neue, sans-serif;

  font-size: 14px;
  color: rgb(3, 56, 120) !important;
}

.card {
  background-color: #F8F8F8;
  will-change: box-shadow;
  display: block;
  position: relative;
  padding: 24px;
  border-radius: 2px;
  padding: 24px;
  border: 0px;
  border-radius: 2px;
  height: 100%;
  word-wrap: inherit;
  border-radius: 8px;
}

.table {
  color: inherit;
}

.card .card-body {
  padding: 0px;
}

.h1,
h1 {
  font-size: 1.5em;
}

.h2,
h2 {
  font-size: 1.8em;
}

.h3,
h3 {
  font-size: 1.7em;
}

.h4,
h4 {
  font-size: 1.5em;
}

.h5,
h5 {
  margin-bottom: 15px;
  font-size: 1.3em;
}

.h1,
.h2,
.h3,
h1,
h2,
h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 600;
}

a {
  background-color: transparent;
  color: rgb(3, 56, 120);
  text-decoration: underline;
}

a:active,
a:hover,
a:focus {
  outline: 0;
  text-decoration: none;
  color: #1f9191;
}

strong {
  font-weight: 700;
}

table {
  border-spacing: 0;
  border-collapse: collapse;
}

.table>tbody>tr>td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: middle;
  border-top: 1px solid #ddd;
}

@media screen and (max-width: 767px) {
  .card img {
    max-width: auto;
    max-height: 150px;
  }
}

.btn-primary {
  color: #fff;
  background-color: rgb(4, 43, 96);
  ;
  border-color: rgb(4, 43, 96);
  ;
}

.btn-primary:hover,
.btn-primary:active,
.btn-primary:focus {
  color: #fff;
  background-color: #1f9191;
  border-color: #1f9191;
}


#go-top {
  cursor: pointer;
  color: #ddd;
  font-size: 25px;
  font-weight: 900;
  position: fixed;
  right: 14px;
  bottom: 14px;
  width: 32px;
  height: 32px;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
  z-index: 10;
  text-align: center;
  -webkit-transition: color .1s linear, border-color .1s linear;
  transition: color .1s linear, border-color .1s linear, opacity .3s linear;
  line-height: normal;
  opacity: 0;
}

#go-top:hover {
  color: #666;
  border-color: #666;
}

#go-top.can-scroll {
  opacity: 1;
}

.chat-indicator {
  position: relative;
}

.chat-indicator:after {
  content: "\25CF";
  position: absolute;
  right: 0px;
  top: 0.4em;
  color: red;
}

a.chat-indicator:after {
  top: -2px;
  right: -13px;
}

.chat-indicator.online:after {
  color: #17F021;
}

.tox-editor-container {
  z-index: 3
}
</style>
